import React from 'react'
import Layout from '../components/UnifyLayout'
import Container from '../components/Container'
import PageTitle from '../components/PageTitle'
import ContactForm from '../components/ContactForm'
import NewsletterSignup from '../components/NewsletterSignup'
import SEO from '../components/SEO'

const Contact = ({ data }) => {
  return (
    <Layout>
      <SEO title="Contact" description="Contact Hempgrid" />
      <section className="container g-py-100">
        <div className="row g-mb-20">
          <div className="col-lg-6 g-mb-50">
            {/* Heading */}
            <h2 className="h1 g-color-black g-font-weight-700 mb-4">How can we help?</h2>
            <p className="g-font-size-18 mb-0">Hempgrid exists to connect and grow the Hemp industry. Let us know what you're looking for.</p>
            {/* End Heading */}
          </div>
          <div className="col-lg-3 align-self-end ml-auto g-mb-50">
            <div className="media">
              <div className="d-flex align-self-center">
                <span className="u-icon-v2 u-icon-size--sm g-color-white g-bg-primary rounded-circle mr-3">
                  <i className="g-font-size-16 icon-communication-033 u-line-icon-pro" />
                </span>
              </div>
              <div className="media-body align-self-center">
                <h3 className="h6 g-color-black g-font-weight-700 text-uppercase mb-0">Phone Number</h3>
                <p className="mb-0"><a href="tel:+18336884367">+1 833.688.HEMP</a></p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 align-self-end ml-auto g-mb-50">
            <div className="media">
              <div className="d-flex align-self-center">
                <span className="u-icon-v2 u-icon-size--sm g-color-white g-bg-primary rounded-circle mr-3">
                  <i className="g-font-size-16 icon-communication-062 u-line-icon-pro" />
                </span>
              </div>
              <div className="media-body align-self-center">
                <h3 className="h6 g-color-black g-font-weight-700 text-uppercase mb-0">Email Address</h3>
                <p className="mb-0"><a href="mailto:hello@hempgrid.com">hello@hempgrid.com</a></p>
              </div>
            </div>
          </div>
        </div>
        <ContactForm name="contact" />
      </section>

      <NewsletterSignup />
    </Layout>
  )
}

export default Contact
